import { styled, rootShouldForwardProp } from '../../styled';
export var AppBarActionsComponentName = 'QuantumAppBarActions';
export var AppBarActions = styled('div', {
    name: AppBarActionsComponentName,
    slot: 'Root',
    shouldForwardProp: function (prop) { return rootShouldForwardProp(prop) && prop !== 'disableSpacing'; },
})(function (_a) {
    var theme = _a.theme, disableSpacing = _a.disableSpacing;
    return ({
        display: 'flex',
        alignItems: 'center',
        '& > :not(:last-child)': {
            marginRight: !disableSpacing ? theme.spacing(2) : 'inherit',
        },
    });
});
